import { isIncludeExclude } from '../FormComponents';

type ErrorPath = (string | number)[];

/**
 * Reads messages out of the nested validation-error object the panel hands each section.
 * `first` takes several paths because some errors are keyed by the backend field name
 * (criteriaMinAge) and others by the state field name (minAge), depending on the validator.
 */
export function errorReader(errors: Record<string, unknown> | undefined) {
  const root = (errors || {}) as Record<string, unknown>;

  const get = (path: ErrorPath): string | undefined => {
    let current: unknown = root;
    for (const key of path) {
      if (current == null || typeof current !== 'object') return undefined;
      current = (current as Record<string | number, unknown>)[key];
    }
    return typeof current === 'string' ? current : undefined;
  };

  const first = (...paths: ErrorPath[]): string | undefined => {
    for (const path of paths) {
      const message = get(path);
      if (message) return message;
    }
    return undefined;
  };

  return { get, first };
}

/** A scalar or list counts as set when it isn't empty; false and 0-length lists don't. */
export function hasValue(value: unknown): boolean {
  if (Array.isArray(value)) return value.length > 0;
  return value !== '' && value !== null && value !== undefined && value !== false;
}

export { isIncludeExclude };
